import React, { useEffect } from 'react';
import * as Sentry from '@sentry/browser';
import './styles.scss';
import { useOpts } from './context';
import ModalWrapper from './ModalWrapper';
import SandboxBannerLinkApi from './LinkApiRouter/views/SandboxBanner/SandboxBanner';
var LinkModal = function (_a) {
    var unMount = _a.unMount, children = _a.children;
    var opts = useOpts();
    var open = opts.open, linkTokenPayload = opts.linkTokenPayload;
    var mode = linkTokenPayload.mode, tokenId = linkTokenPayload.tokenId;
    useEffect(function () {
        Sentry.setTag('mode', mode);
        Sentry.setTag('tokenId', tokenId);
        // TODO: PP-5366
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React.useEffect(function () {
        if (!open) {
            unMount();
        }
        // TODO: PP-5366
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalWrapper, null, children),
        React.createElement(SandboxBannerLinkApi, null)));
};
export default LinkModal;
